import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { configureAmplify } from '../../config/aws.config';
import { AuthService } from '../../services/auth.service';
import { AWSSettings } from '../../models/aws-settings.model';
import { SingleResultApiResponse } from '../../models/api-response.model';
import { LookupService } from '../../services/lookup.service';
import { AWSCognitoErrorResponse } from '../../models/error.model';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'online-app-agent-account-registration',
  templateUrl: './agent-account-registration.component.html',
  styleUrls: ['./agent-account-registration.component.scss'],
  host: {
    class:'full-view-port-component-with-no-side-nav'
  }
})
export class AgentAccountRegistrationComponent implements OnInit {

  accountCreationFormGroup: FormGroup;
  agentEmail = '';
  isFormSubmitted = false;
  isNewPasswordRequired = false;
  invalidLink = false;
  user: any;
  customErrorMsg = '';

  constructor(private formBuilder: FormBuilder,
    private authService: AuthService,
    private lookupService: LookupService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: Title) {
      this.titleService.setTitle("Online Application Portal - DE International - Agent");
    }

  ngOnInit() {

    this.lookupService.getAWSAuthSettings(true)
      .subscribe((response: SingleResultApiResponse) => {



        if (response.Result) {

          const awsSettings: AWSSettings = {
            Region: response.Result.Region,
            UserPoolId: response.Result.UserPoolId,
            UserPoolWebClientId: response.Result.UserPoolWebClientId,
            IdentityPoolId: response.Result.IdentityPoolId,
            AuthenticationFlowType: response.Result.AuthenticationFlowType,
            BucketName: response.Result.BucketName
          };

          localStorage.setItem('awsSettings', JSON.stringify(awsSettings));

          configureAmplify(true);

          const username = this.activatedRoute.snapshot.queryParamMap.get('username');
          this.agentEmail = this.activatedRoute.snapshot.queryParamMap.get('email');
          const tempPassword = this.activatedRoute.snapshot.queryParamMap.get('tempPassword');

          //console.log(`Username: ${username}, tempPassword:${tempPassword}`);

          if (username && tempPassword) {
            this.authService.agentLogin(username, tempPassword)
              .subscribe(user => {
                if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
                  //console.log('got challenge NEW_PASSWORD_REQUIRED');
                  this.isNewPasswordRequired = true;
                  this.user = user;
                }
              }, err => {
                //console.log('error happened');
                this.invalidLink = true;
                console.log(err);
              }, () => {}
            );

          }

        }

      }, err => {
        console.log('error happened while calling AWS Auth Settings');
      });

    this.accountCreationFormGroup = this.formBuilder.group(
      {
        accountPassword: ['', [Validators.required, Validators.minLength(8)]],
        confirmPassword: ['', [Validators.required, Validators.minLength(8)]]
      }
    );



  }

  validatePasswords(): { [key: string]: boolean } | null {
    const accountPassword = this.accountCreationFormGroup.get('accountPassword').value;
    const confirmPassword = this.accountCreationFormGroup.get('confirmPassword').value;
    return accountPassword && accountPassword === confirmPassword
      ? null
      : { passwordsDontMatch: true };
  }

  changePassword() {

    this.isFormSubmitted = true;
    const accountPassword = this.accountCreationFormGroup.get('accountPassword').value;
    const confirmPassword = this.accountCreationFormGroup.get('confirmPassword').value;

    if (accountPassword !== confirmPassword) {
      this.accountCreationFormGroup.get('accountPassword').setErrors({ passwordsDontMatch: true });
      this.accountCreationFormGroup.updateValueAndValidity();
      return;
    }

    if (this.accountCreationFormGroup.valid && this.isNewPasswordRequired) {
      this.authService.completeAgentNewPassword(this.user, this.agentEmail, accountPassword)
        .subscribe(user => {
          //console.log(user);
          //console.log('successfully set the password');

          this.authService.verifyUserEmail(this.agentEmail)
            .subscribe(response => {
              //console.log('successfully verified the user email');
              this.router.navigate(['/welcome-agent']);

            }, error => {
              //console.log('error while verifying user email');
              console.log(error);
            });


        }, (err: AWSCognitoErrorResponse) => {

          if (err.code === 'InvalidParameterException') {
            this.accountCreationFormGroup.get('accountPassword').setErrors({ passwordStrength: true });
          } else {
            this.accountCreationFormGroup.get('accountPassword').setErrors({ customError: true });
            this.customErrorMsg = err.message;
          }

          this.accountCreationFormGroup.updateValueAndValidity();

          console.log(
            'error happened while registering the user with AWS Cognito'
          );
          console.log(err);
        });
    }

  }

  errorPasswordAccessibility(): string{
    if(this.isFormSubmitted &&
      this.accountCreationFormGroup.get('accountPassword').errors &&
      this.accountCreationFormGroup.get('accountPassword').errors.required){
        return "requiredPassword";
    }else if(this.isFormSubmitted &&
      this.accountCreationFormGroup.get('accountPassword').errors &&
      this.accountCreationFormGroup.get('accountPassword').errors.passwordsDontMatch){
        return "matchPassword";
    }else if(this.isFormSubmitted &&
      this.accountCreationFormGroup.get('accountPassword').errors &&
      this.accountCreationFormGroup.get('accountPassword').errors.passwordStrength){
        return "strengthPassword";
    }else if(this.isFormSubmitted &&
      this.accountCreationFormGroup.get('accountPassword').errors &&
      this.accountCreationFormGroup.get('accountPassword').errors.minlength){
        return "minlengthPassword";
    }else if(this.isFormSubmitted &&
      this.accountCreationFormGroup.get('accountPassword').errors &&
      this.accountCreationFormGroup.get('accountPassword').errors.customError){
        return "customErrorPassword";
    }else {
      return "";
    }
  }

  errorConfirmPasswordAccessibility(): string {
    if (this.isFormSubmitted &&
      this.accountCreationFormGroup.get('confirmPassword').errors &&
      this.accountCreationFormGroup.get('confirmPassword').errors.required) {
      return "reEnterConfirmPassword";
    } else if (this.isFormSubmitted &&
      this.accountCreationFormGroup.get('confirmPassword').errors &&
      this.accountCreationFormGroup.get('confirmPassword').errors.minlength) {
      return "minlengthConfirmPassword";
    } else {
      return "";
    }
  }
}
